import COLOR from "../../constants/colors";

const styles = {
  item: {
    background: COLOR.white,
    padding: 24,
    marginBottom: 24,
    fontSize: "1rem",
  },
};

export default styles;
